import { useCallback } from 'react'

export const useFullScreen = refElement => {
    
    // eslint-disable-next-line no-restricted-globals
    const isFullScreen = () => document.fullscreenElement !== null
    
    const toggleFullScreen = useCallback(() => {
        
        if (!isFullScreen())
            refElement.current?.requestFullscreen()
        // eslint-disable-next-line no-restricted-globals
        else if (document.exitFullscreen)
            // eslint-disable-next-line no-restricted-globals
            document.exitFullscreen()
        
    }, [refElement])
    
    return {
        isFullScreen,
        toggleFullScreen,
    }
    
}
